'use client';

import { GoogleTagManager, sendGTMEvent } from '@next/third-parties/google';
import { useEffect } from 'react';

const InjectGoogleTagManager = () => {
  useEffect(() => {
    if (window.__gtmInitialized) return;
    window.__gtmInitialized = true;

    sendGTMEvent({
      event: 'consent',
      type: 'default',
      data: {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      },
    });

    const _hsp = (window._hsp = window._hsp || []);
    _hsp.push([
      'addPrivacyConsentListener',
      (consent: any) => {
        const hasAnalyticsConsent =
          consent?.allowed || consent?.categories?.analytics;
        const hasAdsConsent =
          consent?.allowed || consent?.categories?.advertisement;

        sendGTMEvent({
          event: 'consent',
          type: 'update',
          data: {
            ad_storage: hasAdsConsent ? 'granted' : 'denied',
            analytics_storage: hasAnalyticsConsent ? 'granted' : 'denied',
            ad_user_data: hasAdsConsent ? 'granted' : 'denied',
            ad_personalization: hasAdsConsent ? 'granted' : 'denied',
          },
        });
      },
    ]);
  }, []);

  return <GoogleTagManager gtmId="GTM-5J4HTZK" />;
};

export default InjectGoogleTagManager;
